module.exports = __webpack_public_path__ + "static/media/scarfreefoundation.dcc86833.jpg";